import { render, staticRenderFns } from "./subject-detail.vue?vue&type=template&id=cdd06154&scoped=true&"
import script from "./subject-detail.vue?vue&type=script&lang=ts&"
export * from "./subject-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd06154",
  null
  
)

export default component.exports